import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Debug' },
    { value: 2, label: 'Warning' },
    { value: 3, label: 'Error' },
  ],
});
